import { Box, Grid } from "@mui/material";
import CustomText from "../components/CustomText";

const CustomPrinciples = () => {
  return (
    <Box sx={design.Container}>
      <Box sx={design.Content}>
        <Box sx={design.Header}>
          <CustomText
            color="#782A9F"
            fontWeight={700}
            fontFamily="Nunito"
            textAlign="center"
            sx={design.Label}
          >
            NUESTROS PRINCIPIOS
          </CustomText>
          <CustomText
            color="#171717"
            fontWeight={700}
            fontFamily="Nunito"
            textAlign="center"
            sx={design.Title}
          >
            Los principios que guían cada decisión
          </CustomText>
          <CustomText
            color="#333"
            fontWeight={400}
            fontFamily="Nunito"
            textAlign="center"
            sx={design.Description}
          >
            En Medam nos regimos por una serie de valores fundamentales que
            guían nuestra práctica médica y nuestra relación con la comunidad.
          </CustomText>
        </Box>
        <Grid container>
          <Grid size={design.grid2} />
          <Grid container size={design.grid8}>
            {principles.map((item) => (
              <Grid key={item.title} size={design.grid5} sx={design.GridItem}>
                <Box sx={design.Card}>
                  <Box
                    component="img"
                    src={item.image}
                    alt={item.title}
                    sx={design.CardImage}
                  />
                  <Box sx={design.CardContent}>
                    <CustomText
                      color="#333"
                      fontWeight={700}
                      fontFamily="Nunito"
                      textAlign="center"
                      sx={design.CardTitle}
                    >
                      {item.title}
                    </CustomText>
                    <CustomText
                      color="#444"
                      fontWeight={400}
                      fontFamily="Nunito"
                      textAlign="center"
                      sx={design.CardDescription}
                    >
                      {item.description}
                    </CustomText>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
          <Grid size={design.grid2} />
        </Grid>
      </Box>
    </Box>
  );
};

export default CustomPrinciples;

const design = {
  Container: {
    py: { xs: 2, sm: 6, md: 5 },
    position: "relative",
    overflow: "hidden",
    backgroundImage:
      "url('https://centromedicomedam.com/IMG/centromedicoMEDAM/background_mini_logos_paquetes_del_centro-medico_MEDAM.png')",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
  },
  Content: {
    position: "relative",
    zIndex: 1,
    mx: "auto",
    px: { xs: 2, sm: 3, md: 0 },
  },
  Header: {
    textAlign: "center",
    mb: { xs: 3.5, md: 5 },
  },
  Label: {
    fontSize: { xs: "15px", sm: "10px", md: "14px" },
    letterSpacing: "2px",
    mb: 0.4,
    textTransform: "uppercase",
  },
  Title: {
    fontSize: { xs: "24px", sm: "23px", md: "30px" },
    lineHeight: 1.15,
    mb: 1,
  },
  Description: {
    fontSize: { xs: "20px", sm: "11px", md: "18px" },
    lineHeight: 1.4,
    mx: "auto",
    px: { xs: 1, md: 0 },
  },
  Card: {
    width: { xs: "99%", md: "95%" },
    height: { xs: "auto", sm: "250px", md: "295px" },
    marginBottom: 3,
    borderRadius: "20px",
    overflow: "hidden",
    backgroundColor: "#e9e9e9",
    boxShadow:
      "0px 5px 12px rgba(0, 0, 0, 0.20), 0px 1px 3px rgba(0, 0, 0, 0.10)",
    transition: "transform 0.25s ease, box-shadow 0.25s ease",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow:
        "0px 9px 20px rgba(0, 0, 0, 0.22), 0px 2px 5px rgba(0, 0, 0, 0.10)",
    },
  },
  CardImage: {
    display: "block",
    width: "100%",
    height: { xs: "auto", sm: "105px", md: "155px" },
    objectFit: "cover",
    objectPosition: "center",
  },
  CardContent: {
    minHeight: { xs: "auto", sm: "105px", md: "105px" },
    backgroundColor: "#e9e9e9",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    px: { xs: 1, sm: 1.8, md: 1.7 },
    py: { xs: 1, sm: 1.4, md: 1.4 },
  },
  CardTitle: {
    fontSize: { xs: 23, sm: 23, md: 22 },
    lineHeight: 1.15,
    mb: { xs: 1, md: 0.8 },
  },
  CardDescription: {
    fontSize: { xs: "16px", sm: "16px", md: "15px" },
    lineHeight: 1.35,
    maxWidth: "95%",
  },
  grid2: { xs: 0.5, md: 2, xl: 2, lg: 2 },
  grid8: { xs: 11, md: 8, xl: 8, lg: 8 },
  grid5: { xs: 12, sm: 6, md: 4, xl: 4, lg: 4 },
};

const principles = [
  {
    title: "Calidad",
    description:
      "Brindamos diagnósticos y tratamientos con precisión, eficacia y apego a los más altos estándares clínicos.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Valores_Medam_Calidad.jpg",
  },
  {
    title: "Seguridad",
    description:
      "Priorizamos entornos seguros para pacientes, personal y visitantes en cada nivel de atención.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Valores_Medam_Seguridad.png",
  },
  {
    title: "Confianza",
    description:
      "Construimos relaciones sólidas y duraderas a través de resultados, transparencia y trato digno.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Valores_Medam_Confianza.jpg",
  },
  {
    title: "Empatía y Respeto",
    description:
      "Escuchamos y acompañamos a cada persona con sensibilidad, comprensión y respeto por su dignidad.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Valores_Medam_Respeto.jpg",
  },
  {
    title: "Ética",
    description:
      "Actuamos con integridad, responsabilidad y profesionalismo en cada decisión.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Valores_Medam_Etica.jpg",
  },
  {
    title: "Innovación",
    description:
      "Incorporamos tecnología y soluciones digitales para anticiparnos a las necesidades médicas de nuestra comunidad.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Valores_Medam_Inovacion.jpg",
  },
  {
    title: "Compromiso Social",
    description:
      "Trabajamos por el bienestar colectivo y el desarrollo regional con una visión incluyente y solidaria.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Valores_Medam_Compromiso.jpg",
  },
];
